import { BasicComponentOption } from '@/types';

export const FL_COLUMNS = 1000;
export const FL_ROWS = 1000;

export enum LayoutMenuAction {
  SELECT = 'SELECT',
  DELETE = 'DELETE',
  BOOKMARK = 'BOOKMARK',
  RESET = 'RESET',
  NAVIGATE = 'NAVIGATE',
}

export const CARD_COMPONENT_NAME = 'CardComponent';
export const COMPONENT_NAMES = {
  SESSIONS: 'Contacts',
  TIMELINE: 'Timeline',
  CONTACT_INFO: 'ContactInfo',
  NOTEPAD: 'Notepad',
  CARD_COMPONENT: CARD_COMPONENT_NAME,
};

export const COMPONENT_CATEGORY_KEYS = {
  BASIC: 'basic',
  CARD: 'card',
};

export const BASIC_COMPONENTS: BasicComponentOption[] = [
  {
    key: 'sessions',
    component: COMPONENT_NAMES.SESSIONS,
    category: COMPONENT_CATEGORY_KEYS.BASIC,
    label: 'HITL.common.layout.components.sessions',
    minHeight: 5,
    minWidth: 5,
  },
  {
    key: 'timeline',
    component: COMPONENT_NAMES.TIMELINE,
    category: COMPONENT_CATEGORY_KEYS.BASIC,
    label: 'HITL.common.layout.components.timeline',
    minHeight: 5,
    minWidth: 5,
  },
  {
    key: 'contact',
    component: COMPONENT_NAMES.CONTACT_INFO,
    category: COMPONENT_CATEGORY_KEYS.BASIC,
    label: 'HITL.common.layout.components.contact-info',
    minHeight: 5,
    minWidth: 5,
  },
  {
    key: 'notepad',
    component: COMPONENT_NAMES.NOTEPAD,
    category: COMPONENT_CATEGORY_KEYS.BASIC,
    label: 'HITL.common.layout.components.notepad',
    minHeight: 5,
    minWidth: 5,
  },
];
export const BASIC_COMPONENT_KEYS = BASIC_COMPONENTS.map(c => c.key);
